export class ProfileDetails {
  constructor(person) {
    // Dirección
    this.addresses = {
      addressInfo: []
    };
    if (person.direccion) {
      this.addresses.addressInfo.push({
        address: {
          addressLine: [person.direccion],
          language: 'E',
          type: 'HOME',
          primaryInd: true,
          isValidated: false
        }
      });
    }

    // Teléfono
    this.telephones = {
      telephoneInfo: []
    };
    if (person.phoneNumber) {
      this.telephones.telephoneInfo.push({
        telephone: {
          phoneNumber: person.phoneNumber,
          phoneTechType: "PHONE",
          phoneUseType: "HOME",
          orderSequence: "1",
          primaryInd: true
        }
      });
    }

    // Nombre
    this.customer = {
      personName: [],
      language: 'E',
      privateProfile: false
    };

    if (person.nombre?.trim() || person.apellido?.trim()) {
      this.customer.personName.push({
        givenName: person.nombre?.trim() || '',
        surname: person.apellido?.trim() || '',
        nameType: 'Primary'
      });
    }

    // Otros campos
    this.emails = { emailInfo: [] };
    this.mailingActions = { active: true };
    this.privacyInfo = {
      marketResearchParticipation: true,
      infoFromThirdParty: true,
      autoEnrollLoyaltyProgram: false,
      allowPhone: true,
      allowSMS: true,
      allowEmail: true,
      optInMailingList: true,
      optInMarketResearch: true,
      optInThirdParty: true,
      optInAutoEnrollmentMember: false,
      optInPhone: true,
      optInSms: true,
      optInEmail: true
    };
    
    this.statusCode = "active";
    this.markAsRecentlyAccessed = true;
    this.profileType = "Guest";
  }
}
